import { ChangeDetectionStrategy, Component, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ClickOutside } from '@shared/directives/click-outside';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { ESortDirection } from '@shared/components/collections/collection.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sort',
  imports: [
    FormsModule,
    ClickOutside,
    ButtonComponent,
    TranslateModule,
  ],
  templateUrl: './sort.component.html',
  styleUrl: './sort.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SortComponent {
  isOpen = signal<boolean>(false);

  sortModel = model({
    sortField: 'title',
    sortOrder: ESortDirection.Asc,
  });

  sortField: 'title' | 'lastModified' = 'title';
  sortOrder: ESortDirection = ESortDirection.Asc;

  protected readonly BUTTON_TYPES = BUTTON_TYPES;
  protected readonly ESortDirection = ESortDirection;

  clickOutside(): void {
    this.isOpen.set(false);
  }

  toggleDropdown(): void {
    this.isOpen.set(!this.isOpen());
  }

  setSortOrder(value: ESortDirection): void {
    this.sortOrder = value;
  }

  setSortField(value: 'title' | 'lastModified'): void {
    this.sortField = value;
  }

  updateModel() {
    this.sortModel.set({
      sortField: this.sortField,
      sortOrder: this.sortOrder,
    });
    this.clickOutside();
  }
}
